
import { AuthService } from "@/services/auth-service";
import Vue from "vue";
import { Company } from "../../models/company";

export default Vue.extend({
	props: {},
	computed: {
		daysTillActivation(): string {
			if (this.wfCompany) {
				var d1 = this.wfCompany.ActiveUntil;
				var diff = d1.getTime() - new Date().getTime();
				return (diff / (1000 * 3600 * 24)).toFixed(0);
			}
			return "";
		},
		dayMsg(): string {
			return this.$ct("till", {days: this.daysTillActivation}).toString();
		},
		dayBeforeMsg(): string {
			return this.$ct("till-next", {days: this.daysTillActivation}).toString();
		},
		wfCompany(): Company {
			return AuthService.wfCompany;
		},
		isDemo():boolean{
			return this.wfCompany.IsDemo;
		}
	},
	watch: {},
	i18nEx: {
		componentPrefix: "components.account.tinyInfo"
	}
});
